
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_RESET = 'UPDATE_RESET';

export const race = {
  GET_RACE1_SUCCESS: 'GET_RACE1_SUCCESS',
  GET_RACES_SUCCESS: 'GET_RACES_SUCCESS',
}

export const scratch = {
  GET_SCRATCHESRESULTS_SUCCESS: 'GET_SCRATCHESRESULTS_SUCCESS',
  GET_SCRATCHESSTARTLIST_SUCCESS: 'GET_SCRATCHESSTARTLIST_SUCCESS',
}

export const pointsRace = {
  GET_POINTSRACESTARTLIST_SUCCESS: 'GET_POINTSRACESTARTLIST_SUCCESS',
  GET_POINTSRACERESULTS_SUCCESS: 'GET_POINTSRACERESULTS_SUCCESS',
  GET_POINTSRACESPRINTS_SUCCESS: 'GET_POINTSRACESPRINTS_SUCCESS',
};

export const TT = {
  GET_TTSTARTLIST_SUCCESS: 'GET_TTSTARTLIST_SUCCESS',
  GET_TTRESULTS_SUCCESS: 'GET_TTRESULTS_SUCCESS',
}

export const keirin = {
  GET_KEIRINSTARTLIST_SUCCESS: 'GET_KEIRINSTARTLIST_SUCCESS',
  GET_KEIRINRESULTS_SUCCESSS: 'GET_KEIRINRESULTS_SUCCESSS',
}

export const sprintTournament = {
  GET_SPRINTTOURNAMENT_STARTLIST_SUCCESS: 'GET_SPRINTTOURNAMENT_STARTLIST_SUCCESS',
  GET_SPRINTTOURNAMENT_RESULTS_SUCCESS: 'GET_SPRINTTOURNAMENT_RESULTS_SUCCESS',
}

export const live = {
  GET_LIVE_SUCCESS: 'GET_LIVE_SUCCESS',
  GET_HOMELINE_SUCCESS: 'GET_HOMELINE_SUCCESS',
  GET_BACKLINE_SUCCESS: 'GET_BACKLINE_SUCCESS',
}

